export default "__VITE_ASSET__9108cbfe__"